type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'accent';
const TONES: Record<Tone, string> = {
  neutral: 'bg-surface-3 text-ink-3 border-border',
  info:    'bg-accent-soft text-accent-ink border-accent/30',
  success: 'bg-success/10 text-success border-success/30',
  warning: 'bg-warning/10 text-warning border-warning/30',
  danger:  'bg-danger/10 text-danger border-danger/30',
  accent:  'bg-accent-soft text-accent border-accent/30',
};

export function Badge({ tone = 'neutral', children, mono = false }: { tone?: Tone; mono?: boolean; children: React.ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[11px] border ${mono ? 'font-mono' : ''} ${TONES[tone]}`}>
      {children}
    </span>
  );
}
